import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import '../PrintStyles.css'; // Gunakan CSS print seperti serah terima nota

const STInvoicePreview = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { fromDate = '', toDate = '', invoiceNumbers = [] } = location.state || {};

  return (
    <div className="a4-paper bg-white text-black min-h-screen pl-64 pt-10 p-8 mx-auto print:pl-0 print:pt-0 print:p-10 print:m-0">
      <h1 className="text-2xl font-bold text-center mb-6">SERAH TERIMA INVOICE</h1>

      <div className="text-sm mb-6 space-y-2">
        <div><span className="font-semibold">Tanggal Nota:</span> {fromDate} s.d. {toDate}</div>
        <div><span className="font-semibold">Jumlah Invoice:</span> {invoiceNumbers.length}</div>
      </div>

      <p className="font-semibold text-sm mb-2">Nomor Invoice:</p>
      <ul className="list-decimal list-inside text-sm mb-8">
        {invoiceNumbers.map((inv, idx) => (
          <li key={idx}>{inv || '-'}</li>
        ))}
      </ul>

      <div className="flex justify-between mt-16 text-sm">
        <div className="text-center w-1/2">
          <p className="font-semibold mb-6">Pemberi</p>
          <div className="h-24 border-t border-black w-3/4 mx-auto" />
          <p className="mt-2">(Nama)</p>
          <p className="mt-1">Tanggal: ..............</p>
        </div>
        <div className="text-center w-1/2">
          <p className="font-semibold mb-6">Penerima</p>
          <div className="h-24 border-t border-black w-3/4 mx-auto" />
          <p className="mt-2">(Nama)</p>
          <p className="mt-1">Tanggal: ..............</p>
        </div>
      </div>

      <div className="mt-10 flex justify-end gap-3 print:hidden">
        <button
          onClick={() => navigate(-1)}
          className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600"
        >
          Kembali
        </button>
        <button
          onClick={() => window.print()}
          className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700"
        >
          Cetak
        </button>
      </div>
    </div>
  );
};

export default STInvoicePreview;
